import * as yup from 'yup'
import { ContactSchema, INewContact } from 'apps/fleet-planner/schema/ContactSchema'
import * as Types from 'apps/fleet-planner/types'

const requiredMessage = 'This field is required.'

export interface INewCustomer extends Pick<Types.ICustomer, 'name' | 'notes'> {
  id?: string
  contact: INewContact
}

/**
 * Creates a new customer
 * @note This model is not a 1-to-1 match to ICustomer. It reshapes the request and
 * makes `contact` into an object instead of an array. This works better in the context
 * of a form object.
 * @see https://fp-staging.transfix.io/api-docs/index.html#/Customers/post_customers
 */
export const CustomerSchema = yup.object<INewCustomer>({
  id: yup.mixed(),
  name: yup.string().required(requiredMessage),
  contact: ContactSchema,
  notes: yup.string().notRequired(),
})

export type CustomerSchemaType = yup.InferType<typeof CustomerSchema>

/**
 * Creates object for POST /customers request
 * based on form output
 * @param {CustomerSchemaType} data - Form output
 */
export const createNewCustomerRequest = (
  data: CustomerSchemaType
): Pick<Types.ICustomer, 'name' | 'notes' | 'contacts'> => {
  const { contact, name, notes } = data || {}
  return {
    name,
    contacts: [
      {
        ...contact,
        purpose: Types.CUSTOMER_CONTACT_PURPOSE.PRIMARY,
      },
    ],
    notes,
  }
}
